<template>
  <div v-if="brands.length">
    <div class="d-block d-sm-none">
      <div class="text-left title mb-3">{{ $t('brand_selector.filter_by_brand') }}</div>
      <b-button
        v-b-toggle.brands-filters
        variant="secondary-b"
      >{{ $t('brand_selector.title') }}</b-button>
      <b-collapse id="brands-filters" class="mt-2">
        <b-card>
          <vue-element-loading :active="loadingBrands" />
          <ul class="m-0 mb-3 p-0 brand-list">
            <b-row>
              <b-col cols="12" md="12" v-for="(brand, index) in brands" :key="index">
                <li class="text-left text-truncate">
                  <router-link
                    :to="brandRoute(brand)"
                    v-bind:class="{ selected: brand.uuid == selectedBrand }"
                    class="pl-4"
                  >{{ brand.brand }}</router-link>
                </li>
              </b-col>
            </b-row>
          </ul>
        </b-card>
      </b-collapse>
    </div>
    <div class="brand-selector d-none d-sm-block">
      <div class="title mb-3 py-2 text-uppercase">{{ $t('brand_selector.title') }}</div>
      <ul class="brand-list m-0 p-0">
        <li v-for="(brand, index) in brands" :key="index">
          <router-link
            :to="brandRoute(brand)"
            v-bind:class="{ selected: brand.uuid == selectedBrand }"
            class="pl-4"
          >{{ brand.brand }}</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>


<script>
export default {
  name: "brand-selector",
  props: {
    source: String,
    categoryUuid: String,
    groupedCategoryUuid: String,
    pharmacyUuid: String,
    selectedBrand: String,
  },
  data() {
    return {
      brands: [],
      loadingBrands: true,
    };
  },
  watch: {
    source() {
      this.loadBrands();
    },
    categoryUuid() {
      this.loadBrands();
    },
    pharmacyUuid() {
      this.loadBrands();
    },
  },
  mounted() {
    this.loadBrands();
  },
  methods: {
    loadBrands() {
      var payload = {};
      this.loadingBrands = true;
      if (this.categoryUuid) {
        payload.dcUuid = this.categoryUuid;
      }
      if (this.groupedCategoryUuid) {
        payload.groupedCategoryUuid = this.groupedCategoryUuid;
      }
      if (this.pharmacyUuid) {
        payload.doUuid = this.pharmacyUuid;
      }

      this.$store.dispatch(this.source, payload).then(
        response => {
          this.brands = response.data.results;
          this.loadingBrands = false;
        },
        err => {
          this.brands = [];
          this.$sentry({ capture: err });
          this.loadingBrands = false;
        }
      );
    },
    brandRoute(brand) {
      var route = {
        name: this.$route.name,
        params: this.$route.params,
        query: Object.assign({}, this.$route.query),
      };
      if (route.query.brandUuid == brand.uuid){
        // quitamos la selección y limpiamos la consulta
        delete route.query["brandUuid"];
      }else{
        route.query.brandUuid = brand.uuid;
      }
      return route;
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        brand_selector: {
          title: "Brand-Name Drugs",
          filter_by_brand: "Filter by brand",
        },
      },
    },
  },
};
</script>


<style scoped lang="scss">
.title {
  border-bottom: 1px solid $grey4-color;
  border-top: 1px solid $grey4-color;
  font-size: $font-size-medium * 1.1;
  font-weight: bold;
}

li {
  line-height: 2rem;
  list-style: none;
  text-transform: uppercase;
}

a {
  background: url("../static/square.png") no-repeat 0% 1px;
  color: $text-main-color;
}

a:hover {
  background: url("../static/square_round.png") no-repeat 0% 1px;
  color: $text-main-color;
  text-decoration: none;
}

a.selected {
  background: url("../static/square_round.png") no-repeat 0% 1px;
}

@include media-breakpoint-down(sm) {
  .title{
    border-top: 0px;
  }
}

.brand-list {
  height: 20rem;
  overflow-y: auto;
}
</style>
